import { isObject } from './transformObjectProperties';

export const reduceByProperty = <
    T extends Record<string, any>,
    D extends keyof T,
>(
    input: Array<T>,
    property: D,
    propertyTransform?: (inputElement: T[D]) => string,
) => {
    if (input.length === 0) return {};
    /*  
        input
        [{ temp: '20', humidity: '90', }, { humidity: '100', temp: '25' }]
        property 'temp'
        output
        { 20: [{ temp: '20', humidity: '90' }], 25: [{ humidity: '100', temp: '25' }]}
    */
    return input.reduce(
        (currentOutput, currentElement) => {
            const output = { ...currentOutput };

            const propertyValue = propertyTransform
                ? propertyTransform(currentElement[property])
                : currentElement[property];

            if (
                !propertyValue ||
                isObject(propertyValue) ||
                Array.isArray(propertyValue)
            )
                return output;

            /* istanbul ignore else */
            if (!output[propertyValue]) output[propertyValue] = [];
            output[propertyValue].push(currentElement);
            return output;
        },
        {} as Record<string, T[]>,
    );
};
